// Hook React Query para facturas emitidas del cliente en portal /clientes
import { useQuery } from '@tanstack/react-query';
import { clienteService } from '@/services/clienteService';

export function useClienteFacturasQuery() {
  return useQuery({
    queryKey: ['cliente-facturas'],
    queryFn: () => clienteService.getFacturas(),
    staleTime: 30_000,
  });
}
